<template>
    <!--
    Action component
    Styled button component, triggering/calling an action.

    @property {String} value, input value
    @property {String} placeholder, placeholder for searchbar
    @property {String} style, style class to modify component
    -->
    <div class="search" :class="style">
        <input type="search" :placeholder="placeholder" :value="value" @input="updateValue($event.target.value)"
        >
        <icon name="search" viewBox="0 0 24 24" />
    </div>
</template>

<script>
export default
{
    name: 'Search',

    data()
    {
        return {
            style: 'search--framed',
        }
    },

    props:
    {
        placeholder:
        {
            type: String,
            default: '',
        },

        value:
        {
            type: String,
            default: '',
        },

        noBorder:
        {
            type: String,
        }
    },

    created()
    {
        this.style = (typeof this.noBorder == 'undefined') ? this.style : '';
    },

    methods:
    {
        /**
         * Update value to parent component
         * @param value
         */
        updateValue(value)
        {
            this.$emit('input', value);
        },
    },
}
</script>


// WEBPACK FOOTER //
// Search.vue?25dfedb8